import { Box, Button } from '@ff-it/ui';
import { OnEnterPlugin, RichTextEditor } from 'components/RichText';
import { ReactElement, useCallback, useRef, useState } from 'react';
import type { EditorValue } from 'components/RichText/types';

type CommentFormProps = {
  onCreate: (comment: EditorValue) => Promise<void>;
};

export function CommentForm({ onCreate }: CommentFormProps): ReactElement {
  const btnRef = useRef<HTMLButtonElement>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [comment, setComment] = useState<EditorValue | undefined>();

  const onSubmit = async () => {
    if (isSubmitting || !comment) {
      return;
    }

    setIsSubmitting(true);
    await onCreate(comment);
    setComment(undefined);
    setIsSubmitting(false);
  };

  const onEnter = useCallback(() => {
    // FIXME: ugly
    btnRef.current?.click();
  }, []);

  return (
    <Box
      as="form"
      p="4"
      borderTop="default"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <RichTextEditor
        value={comment}
        placeholder="Write a comment..."
        onChange={setComment}
        toolbar={
          <Button
            icon="paper-plane-top"
            type="submit"
            size="xxs"
            disabled={isSubmitting || !comment}
            spin={isSubmitting}
            ml="auto"
            ref={btnRef}
          />
        }
      >
        <OnEnterPlugin onEnter={onEnter} />
      </RichTextEditor>
    </Box>
  );
}
